import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiButtonModule } from '@cigna/shared/angular/button-ui';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';

import { LinkRendererComponent } from './link-renderer.component';
import {
  BoldRendererComponent,
  StrongRendererComponent,
  BreakRendererComponent,
  ItalicRendererComponent,
  EmRendererComponent,
  ParagraphRendererComponent,
  SubRendererComponent,
  SupRendererComponent,
  SpanRendererComponent,
} from './formatting-renderers';
import {
  ButtonRendererComponent,
  IconRendererComponent,
} from './ui-component-renderers';
import { ContentRendererModule } from './content-renderer.module';

const RENDERERS = [
  LinkRendererComponent,
  // formatting
  ParagraphRendererComponent,
  BoldRendererComponent,
  StrongRendererComponent,
  ItalicRendererComponent,
  EmRendererComponent,
  BreakRendererComponent,
  SubRendererComponent,
  SupRendererComponent,
  SpanRendererComponent,
  // UI components
  ButtonRendererComponent,
  IconRendererComponent,
];

@NgModule({
  declarations: [...RENDERERS],
  imports: [CommonModule, UiButtonModule, UiIconModule, ContentRendererModule],
})
export class RendererModule {}
